module.exports = __webpack_public_path__ + "0060fab5af980b31fd21ca35b3980ca2.pdf";